/**
 * Anti-abus UI : empêche double-clic et rafales de requêtes identiques.
 */
export function createSubmitGuard(minIntervalMs = 2500) {
  let inFlight = false;
  let lastSuccessAt = 0;

  return {
    async run(fn) {
      if (inFlight) {
        return { ok: false, reason: 'in_flight' };
      }
      const now = Date.now();
      if (lastSuccessAt && now - lastSuccessAt < minIntervalMs) {
        return { ok: false, reason: 'cooldown' };
      }
      inFlight = true;
      try {
        const result = await fn();
        lastSuccessAt = Date.now();
        return { ok: true, result };
      } finally {
        inFlight = false;
      }
    },
    reset() {
      inFlight = false;
    },
  };
}

export function formatThrottleMessage(error) {
  const status = error?.response?.status;
  if (status === 429) {
    return 'Trop de tentatives. Patientez quelques minutes avant de réessayer.';
  }
  return null;
}

/**
 * Délai minimum avant envoi formulaire public (anti-bot rapide).
 */
export function createFormTimingGuard(minSeconds = 3) {
  const openedAt = Date.now();
  return {
    isReady() {
      return Date.now() - openedAt >= minSeconds * 1000;
    },
    secondsLeft() {
      const left = Math.ceil((minSeconds * 1000 - (Date.now() - openedAt)) / 1000);
      return Math.max(0, left);
    },
  };
}
